import React from 'react';
import { SectionWrapper } from './SectionWrapper';
export const OpeningHook: React.FC = () => {
  return <SectionWrapper className="bg-navy" data-id="element-132">
      <div className="max-w-3xl mx-auto" data-id="element-133">
        <blockquote className="border-l-4 border-gold pl-6 md:pl-8 py-2 mb-8" data-id="element-134">
          <p className="text-xl md:text-2xl text-gray-200 leading-relaxed italic" data-id="element-135">
            "Estás parado frente a la ventanilla. El oficial te mira fijamente,
            apenas revisa tus papeles y lanza la primera pregunta. Tienes
            exactamente 120 segundos para demostrar que no eres un riesgo para
            su país. Si en ese momento dudas, das una respuesta demasiado larga
            o dejas que tus nervios hablen por ti — la respuesta será un No
            rotundo."
          </p>
        </blockquote>
        <p className="text-2xl md:text-3xl font-bold text-white text-center mt-12" data-id="element-136">
          Este protocolo existe para que eso no te pase a ti.
        </p>
      </div>
    </SectionWrapper>;
};